<template>
    <div class="delivery-sec__body" v-if="user">
        <div class="delivery-sec__content-wrapper user-account__layout-wrapper"
             :class="{ 'user-account__layout-wrapper_with-vip': isVip }">
            <div class="user-account__layout" :class="{ 'user-account__layout_with-vip': isVip }">
                <div class="user-account__main">
                    <slot />
                </div>
                <VipInfoBar
                    v-if="isVip"
                    class="user-account__vip-bar_desktop"
                    :discount-percent="vipDiscountPercent"
                />
            </div>
        </div>
    </div>
</template>

<script>
import VipInfoBar from './vip-info-bar.vue'

export default {
    name: 'UserAccountLayout',
    components: {
        VipInfoBar,
    },
    computed: {
        user() {
            return this.$store.state.settings.user
        },
        isVip() {
            return Boolean(this.user?.is_vip)
        },
        vipDiscountPercent() {
            return Number(this.$store.state.settings.vip_discount_percent) || 30
        },
    },
}
</script>
